import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SideMenuService {

  sidebarOpened = true;
  sidebarOpenedSubject = new Subject();

  constructor() {}

  openSidebar() {
    this.sidebarOpened = true;
    this.sidebarOpenedSubject.next(true);
  }

  closeSidebar() {
    this.sidebarOpened = false;
    this.sidebarOpenedSubject.next(true);
  }
}

